import { useMemo, useRef } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

const selectSocketHandlerState = (state) => ({
  incomingCalls: state.voiceReducer?.incomingCalls ?? [],
  activeCall: state.voiceReducer?.activeCall ?? null,
  outboundDialingCall: state.voiceReducer?.outboundDialingCall ?? null
});

export default function useVoiceSocketPorts(retailerId, retailerUserId) {
  const dispatch = useDispatch();
  const dispatchRef = useRef(dispatch);
  dispatchRef.current = dispatch;

  const handlerState = useSelector(selectSocketHandlerState, shallowEqual);
  const handlerStateRef = useRef(handlerState);
  handlerStateRef.current = handlerState;

  return useMemo(() => ({
    identity: {
      retailerId,
      retailerUserId
    },
    dispatch: (...args) => dispatchRef.current(...args),
    getHandlerState: () => handlerStateRef.current
  }), [retailerId, retailerUserId]);
}
